import { shareKeyActions } from '../../../../actions/user/hospital/Account/generate-key';

const initialState = {
  key: null, // The sharing key UUID
  permission: null, // Either 'view' or 'edit'
  expires_at: null, // Expiration timestamp
  loading: false,
  error: null
};

const hospitalGenerateKeyReducer = (state = initialState, action) => {
  switch (action.type) {
    // Request action
    case shareKeyActions.GENERATE_KEY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

      // Success action
    case shareKeyActions.GENERATE_KEY.SUCCESS:
      return {
        ...state,
        loading: false,
        key: action.payload.key,
        permission: action.payload.permission,
        expires_at: action.payload.expires_at,
        error: null
      };

      // Failure action
    case shareKeyActions.GENERATE_KEY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

      // Direct state manipulation actions
    case shareKeyActions.SET_SHARE_KEY:
      return {
        ...state,
        key: action.payload?.key || null,
        permission: action.payload?.permission || null,
        expires_at: action.payload?.expires_at || null
      };

    case shareKeyActions.CLEAR_SHARE_KEY:
      return {
        ...initialState,
        loading: false,
        error: null
      };

    default:
      return state;
  }
};

export default hospitalGenerateKeyReducer;
